import { jdiColorFetch } from '../colorFetchV2';

export const getBasicConfig = async () => {
  return await jdiColorFetch('basic_config_get', {
    method: 'POST',
    bodyQuery: {
      basicConfigType: '2',
    },
  });
};
